export default function search(){
    let desktopSearch = document.getElementById("desktopToggleSearch");
    
    if(desktopSearch){
        let boxSearch = document.querySelector(".border-container");
        var element = document.getElementById("searchInput");

        desktopSearch.addEventListener("click", toggleSearch);
        function toggleSearch(){
            element.classList.toggle("active");
            boxSearch.classList.toggle("active");
        }

        const close = document.querySelector(".close");

        close.addEventListener("click", () => {
            boxSearch.classList.remove("active");
            element.classList.remove("active");
        });
    }
}
